import { Component, OnInit } from '@angular/core';
import { RestService } from '../rest.service';
import { UserService } from '../user.service';
import { Spanish } from 'flatpickr/dist/l10n/es';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ExcelexportService } from '../excelexport.service';

@Component({
  selector: 'app-factbalisa',
  templateUrl: './factbalisa.component.html',
  styleUrls: ['./factbalisa.component.scss']
})
export class FactbalisaComponent implements OnInit {

  rangos: any[] = [];
  data: any[] = [];

  dateSimple;
  dateTime: FlatpickrOptions = {
    enableTime: false,
    dateFormat: 'Y-m-d',
    locale: Spanish,
    onChange: (selectedDates, dateStr, instance) => {
      this.dateSimple = dateStr;
      this.ObtenerFechaComparacion();
    }
  };

  dateComparativa;
  dateTime2: FlatpickrOptions = {
    enableTime: false,
    dateFormat: 'Y-m-d',
    locale: Spanish,
    onChange: (selectedDates, dateStr, instance) => {
      this.dateComparativa = dateStr;
    }
  };

  rango_selected;

  constructor(
    private rest: RestService,
    private excel: ExcelexportService,
    public user: UserService ) {
      this.GetRangos();
      this.GetDefault();
    }

  ngOnInit() {}

  exportXlsx() {


    const promise = new Promise( (resolve) => {
      let general = [];
      let comparativa = [];
      let diferencia = [];

      for (let index = 0; index < this.data.length; index++) {
        general[index] = {
          'concepto' : this.data[index]['concepto'],
          'libertad' : this.data[index]['libertad']['general'],
          'carolinas' : this.data[index]['carolinas']['general'],
          'goya' : this.data[index]['goya']['general'],
          'central' : this.data[index]['central']['general'],
          'santapola' : this.data[index]['santapola']['general'],
        };

        comparativa[index] = {
          'concepto' : this.data[index]['concepto'],
          'libertad' : this.data[index]['libertad']['comparativa'],
          'carolinas' : this.data[index]['carolinas']['comparativa'],
          'goya' : this.data[index]['goya']['comparativa'],
          'central' : this.data[index]['central']['comparativa'],
          'santapola' : this.data[index]['santapola']['comparativa'],
        };

        diferencia[index] = {
          'concepto' : this.data[index]['concepto'],
          'libertad' : this.data[index]['libertad']['diferencia'],
          'carolinas' : this.data[index]['carolinas']['diferencia'],
          'goya' : this.data[index]['goya']['diferencia'],
          'central' : this.data[index]['central']['diferencia'],
          'santapola' : this.data[index]['santapola']['diferencia'],
        };
      }

      resolve([general, comparativa, diferencia]);
    });

    promise.then( (arrayResult: any[]) => {
      this.excel.fact2Export(
        arrayResult[0], arrayResult[1], arrayResult[2],'BALISA_' + this.dateSimple + 'VS' + this.dateComparativa);
    });

  }

  GetRangos() {
    this.rest.GetRangos().subscribe((data) => {
      this.rangos = data['data'];
    });
  }

  ObtenerFechaComparacion() {
    this.rest.Getfecha_comparacion(this.user.formatDate(this.dateSimple))
    .subscribe(
      (data) => this.dateComparativa = data['data'][0]['fecha'] );
  }

  parseInt(myAcc) {
    let intValue = parseInt(myAcc);

    if (intValue >= 0) {
        return true;
    } else {
        return false;
    }
  }

  GetDefault() {
    this.rest.GetDefault().subscribe( (data) => {
      this.rango_selected = data['data'].rango;

      this.dateSimple = {
        year: new Date(data['data'].general).getFullYear(),
        month: new Date(data['data'].general).getMonth() + 1 ,
        day: new Date(data['data'].general).getDate()
      };

      this.dateComparativa = {
        year: new Date(data['data'].comparacion).getFullYear(),
        month: new Date(data['data'].comparacion).getMonth() + 1 ,
        day: new Date(data['data'].comparacion).getDate()
      };

    });
  }

  GetData() {
    this.rest.GetDataBalisa(this.rango_selected.id, this.user.formatDate(this.dateSimple), this.user.formatDate(this.dateComparativa) )
    .subscribe( (data) => this.data = data['data'] );
  }

}
